import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualCreditReq } from "../../../../Redux/Slices/requestManagementSlice";

const CreditRequestDetails = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const [creditRequestData, setCreditRequestData] = useState({
    userName: "Mann",
    MobileNumber: "8379283723",
    CountryCode: "+91",
    EmailID: "user@sample.com",
    CompanyName: "ABC company",
    Industry: "Steel",
    SubIndustry: "Down Stream",
    PlanRequested: "40 Credits / 5 Engineers",
  });
  console.log(creditRequestData);

  useEffect(() => {
    dispatch(
      fetchIndividualCreditReq({
        data: { id },
        callBack: (value) => {
          console.log(value.data);
          setCreditRequestData(value.data);
        },
      })
    );
  }, []);

  return (
    <MainLayout pageName="Requests">
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Requests</p>
      </div>
      <div className="CreditRequestDetailsContainer">
        {/* Header */}
        <div className="CreditRequestDetailsHeader">
          <h2>Credit Request Details</h2>
        </div>
        <hr style={{ backgroundColor: "#E6E6E6" }} />
        <div className="CreditRequestDetails">
          <h3>Request Details</h3>
          <div>
            <p className="CreditRequestDetailLabel">User Name</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.user_details?.firstname}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Mobile Number</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.user_details?.country_code}&nbsp;{creditRequestData?.user_details?.mobile}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Email ID</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.user_details?.email}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Company Name</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.company_name || "-"}
            </p>
          </div>
          {/* <div>
            <p className="CreditRequestDetailLabel">Industry</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.company_name || "-"}
            </p>
          </div> */}
          <div>
            <p className="CreditRequestDetailLabel">Plan Type</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.default_credits_name || "-"}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Plan Requested</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.no_of_credits || "-"}
            </p>
          </div>

          <div>
            <p className="CreditRequestDetailLabel">Department</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.department || "-"}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Position</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.position || "-"}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Purchaser Name</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.purchaser_name || "-"}
            </p>
          </div>
          <div>
            <p className="CreditRequestDetailLabel">Purchase Email ID</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.purchaser_email_id || "-"}
            </p>
          </div>
          {/* <div>
            <p className="CreditRequestDetailLabel">Number of users</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.no_of_users || "-"}
            </p>
          </div> */}
          <div>
            <p className="CreditRequestDetailLabel">Preferred Mode of Payment</p>
            <p className="CreditRequestDetailLabelData">
              : {creditRequestData?.payment_name || "-"}
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default CreditRequestDetails;
